import { useQuery } from '@tanstack/react-query';

import type { MeResponse } from '@redawn/shared-types';

import { ApiCallError, apiFetch } from '../lib/api.ts';

export function useUser() {
  const query = useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        return await apiFetch<MeResponse>('/api/auth/me');
      } catch (err) {
        if (err instanceof ApiCallError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 60_000,
  });

  return {
    user: query.data?.user ?? null,
    isLoading: query.isLoading,
    error: query.error,
  };
}
